import styled from "styled-components";

export const StyledLabel = styled.label`
    pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
`;
